export const transferSettingsData = {
    adminSettings: {
        root: {
            logo: 'logo'
        },
        seller: [
            'companyName',
            'companyEmail',
            'companyAddress_street',
            'companyAddress_city',
            'companyAddress_postCode',
            'companyAddress_region',
            'companyCountry',
            'companyCountryName',
            'logo'
        ],
        buyer: [
            'companyName',
            'companyEmail',
            'companyAddress_street',
            'companyAddress_city',
            'companyAddress_postCode',
            'companyAddress_region',
            'companyCountry',
            'companyCountryName',
            'logo'
        ]
    },
    inventorySettings: {
        settings: [
            'nSeries'
        ]
    },
    projectSettings: {
        root: {
            itemId: 'defaultProductId',
            itemName: 'defaultProductName',
            itemTaxId: 'defaultProductTaxId',
            itemTaxName: 'defaultProductTaxName',
            itemTaxRate: 'defaultProductTaxRate',
            itemNetPrice: 'defaultProductNetPrice'
        }
    },
    purchasesSettings: {
        root: {
            currency: 'defaultCurrency',
            paymentTermId: 'defaultPaymentTermId',
            paymentTermName: 'defaultPaymentTermName',
            paymentTermDays: 'defaultPaymentTermDays'
        },
        settings: [
            'nSeries'
        ]
    },
    salesSettings: {
        root: {
            paymentTermId: 'defaultPaymentTermId',
            paymentTermName: 'defaultPaymentTermName',
            paymentTermDays: 'defaultPaymentTermDays',
            language: 'invoiceLanguage',
            languageName: 'invoiceLanguageName',
            currency: 'invoiceCurrency',
            baseCurrency: 'invoiceCurrency',
            currencyName: 'invoiceCurrencyName',
        },
        settings: [
            'nSeries'
        ]
    },
    serviceSettings: {
        settings: [
            'nSeries'
        ]
    }
}
